import { Button, LegacyCard, LegacyStack } from "@shopify/polaris";
import React from "react";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import styled from "styled-components";

export const ContactSupportBlock = () => {
  const { vendorSupportChat, vendorPortalIntercom } = useSmartrrFlags();

  const handleChatClick = (): void => {
    if (vendorPortalIntercom && window.Intercom) {
      window.Intercom("show");
    } else if (window.zE) {
      // TODO: Remove this once Intercom is fully migrated
      window.zE("messenger", "open");
    } else {
      console.error("Support widget is disabled or widget not loaded");
    }
  };

  const CustomStyles = styled.div`
    .Polaris-LegacyCard > .Polaris-LegacyCard__Section + .Polaris-LegacyCard__Section {
      border-top: 0;
      padding-top: 0;
    }
  `;

  return (
    <CustomStyles>
      <LegacyCard title={"Contact Support"}>
        <LegacyCard.Section>
          Do you have a technical question or support query? Our success team is ready to help.
        </LegacyCard.Section>

        <LegacyCard.Section>
          <LegacyStack spacing="loose">
            {!!vendorSupportChat && (
              <Button primary onClick={handleChatClick}>
                Start a Chat
              </Button>
            )}
            <a className="Polaris-Button Polaris-Button--primary" href={`mailto:support@smartrr.com`}>
              Send an Email
            </a>
          </LegacyStack>
        </LegacyCard.Section>
      </LegacyCard>
    </CustomStyles>
  );
};
